import useSubmitTransitOperation from '../../transit-operation/components/useSubmitTransitOperation'
import useAmendTransitOperation from '../../transit-operation/components/useAmendTransitOperation'
import { TransitEditorAction } from '../../models/types'
import { TransitOperation } from '../../transit-operation/models/types'
import useCancelTransitOperation from '../../transit-operation/components/useCancelTransitOperation'
import usePresentationNotification from '../../transit-operation/components/usePresentationNotification'
import useEnsPresentationNotification from '../../transit-operation/components/useEnsPresentationNotification'

function useCustomsActions(
  transitOperationId: number | null,
  country: string | null,
) {
  const { submitTransitOperation } = useSubmitTransitOperation(transitOperationId)
  const { amendTransitOperation } = useAmendTransitOperation(transitOperationId)
  const { cancelTransitOperation } = useCancelTransitOperation(transitOperationId)
  const { sendEnsPresentationNotification } = useEnsPresentationNotification(transitOperationId)
  const { sendPresentationNotification } = usePresentationNotification(transitOperationId)

  const invokeCustomsAction = async (action: TransitEditorAction, reason?: string): Promise<TransitOperation | null> => {
    switch (action) {
      case 'submit':
        return await submitTransitOperation(country)
      case 'amend':
        return await amendTransitOperation(country)
      case 'cancel':
        return await cancelTransitOperation(reason ?? '')
      case 'presentationNotification':
        return await sendPresentationNotification()
      case 'ensPresentationNotification':
        return await sendEnsPresentationNotification()
      default:
        return null
    }
  }
  return {
    invokeCustomsAction,
  }
}

export default useCustomsActions
